export const MAX_AGE_SELECTED = 69;

export const MIN_AGE_SELECTED = 18;

export const INSURANCE_RANGE_MAX_VALUE_THRESHOLD = 69;

export const FALLBACK_INSURANCE_RANGE_MAX_VALUE = 50;
